<template>

    <div>

        <!--<div v-for="rifat in this.printWorkflow">-->
            <!--{{rifat.name }}-->
            <!--<br>-->
            <!--<div v-for="rif in rifat.filter">-->
                <!--{{rifat.option}}-->
            <!--</div>-->
            <!--<br>-->
            <!--{{rifat.selected_value}}-->
        <!--</div>-->
        <!--<br>-->
        <!--{{this.printSpec}}-->

        <!--{{this.predefinedSelections}}<br>-->

        <div class="layout__position-sticky-container">
            <div class="layout__width-65">

                <div class="layout__width-100 layout__padding-clear layout__overflow-hidden">

                    <el-collapse v-model="subActive" class="layout__width-100 layout__overflow-hidden" v-show="category === 'Stationery' || category === 'Banners & Display boards'">
                        <el-collapse-item title="Select a subcategory" name="Stationery" v-show="category === 'Stationery'">
                        <div class="layout__width-100">
                            <div class="component__columns-4__10px-padding layout__cursor-pointer layout__overflow-hidden"
                                 v-on:click="selectSubcategory(subCatStationery[0])">
                                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/Docufolders.jpg"
                                     class="layout__width-100">
                                <div class="component__product__card-small-subtitle-text">
                                    {{subCatStationery[0].title}}
                                </div>
                            </div>

                            <div class="component__columns-4__10px-padding layout__cursor-pointer"
                                 v-on:click="selectSubcategory(subCatStationery[1])">
                                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/businesscards.jpg"
                                     class="layout__width-100">
                                <div class="component__product__card-small-subtitle-text">
                                    {{subCatStationery[1].title}}
                                </div>
                            </div>

                            <div class="component__columns-4__10px-padding layout__cursor-pointer"
                                 v-on:click="selectSubcategory(subCatStationery[2])">
                                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/ComplimentSlip.jpg"
                                     class="layout__width-100">
                                <div class="component__product__card-small-subtitle-text">
                                    {{subCatStationery[2].title}}
                                </div>
                            </div>

                            <div class="component__columns-4__10px-padding layout__cursor-pointer"
                                 v-on:click="selectSubcategory(subCatStationery[3])">
                                <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/Letterhead.jpg"
                                     class="layout__width-100">
                                <div class="component__product__card-small-subtitle-text">
                                    {{subCatStationery[3].title}}
                                </div>
                            </div>
                        </div>
                        </el-collapse-item>

                        <el-collapse-item title="Select a subcategory" name="Banners & Display boards" v-show="category === 'Banners & Display boards'">
                            <div class="layout__width-50 layout__padding-clear">
                            <div class="component__columns-2 layout__cursor-pointer" v-on:click="selectSubcategory(subCatBanners[0])">
                            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/DisplayBoard.jpg" class="layout__width-100">
                            <div class="component__product__card-small-subtitle-text">{{subCatBanners[0].title}}</div>
                            </div>

                            <div class="component__columns-2 layout__cursor-pointer" v-on:click="selectSubcategory(subCatBanners[1])">
                            <img src="https://rpsassets.blob.core.windows.net/rpsimages/images/products/print/Bannerroll.jpg" class="layout__width-100">
                            <div class="component__product__card-small-subtitle-text">{{subCatBanners[1].title}}</div>
                            </div>
                            </div>
                        </el-collapse-item>
                    </el-collapse>

                </div>

                <el-collapse v-model="activeName" class="layout__width-100">
                    <el-collapse-item title="Choose your size" name="0" v-show="printWorkflow[0].show"
                                      :disabled="printWorkflow[0].disable">
                        <el-radio-group v-model="printWorkflow[0].selected_value" v-on:change="next(printWorkflow[0])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[0].filter" v-model="printWorkflow[0].selected_value">
                                <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                     <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>
                    </el-collapse-item>

                    <el-collapse-item title="Choose your orientation" name="1" v-show="printWorkflow[1].show"
                                      :disabled="printWorkflow[1].disable">
                        <el-radio-group v-model="printWorkflow[1].selected_value" v-on:change="next(printWorkflow[1])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[1].filter" v-model="printWorkflow[1].selected_value">
                                <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                     <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>


                    </el-collapse-item>
                    <el-collapse-item title="Select a page count" name="2" v-show="printWorkflow[2].show"
                                      :disabled="printWorkflow[2].disable">

                        <el-radio-group v-model="printWorkflow[2].selected_value" v-on:change="next(printWorkflow[2])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[2].filter" v-model="printWorkflow[2].selected_value">
                               <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                    <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>


                    </el-collapse-item>
                    <el-collapse-item title="Choose your fold type" name="3" v-show="printWorkflow[3].show"
                                      :disabled="printWorkflow[3].disable">
                        <el-radio-group v-model="printWorkflow[3].selected_value" v-on:change="next(printWorkflow[3])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[3].filter" v-model="printWorkflow[3].selected_value">
                                <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                     <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>


                    </el-collapse-item>
                    <el-collapse-item title="Select a crease style" name="4" v-show="printWorkflow[4].show"
                                      :disabled="printWorkflow[4].disable">


                        <el-radio-group v-model="printWorkflow[4].selected_value" v-on:change="next(printWorkflow[4])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[4].filter" v-model="printWorkflow[4].selected_value">
                                <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                    <!--&lt;!&ndash;<p>{{size.option}}</p>&ndash;&gt;-->
                                       <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>

                    </el-collapse-item>
                    <el-collapse-item title="Select a paper type" name="5" v-show="printWorkflow[5].show"
                                      :disabled="printWorkflow[5].disable">


                        <el-radio-group v-model="printWorkflow[5].selected_value" v-on:change="next(printWorkflow[5])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[5].filter" v-model="printWorkflow[5].selected_value">
                            <!--<img :src="imagePrefix + size + rifat">-->
                               <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                    <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>

                    </el-collapse-item>
                    <el-collapse-item title="Select a paper weight" name="6" v-show="printWorkflow[6].show"
                                      :disabled="printWorkflow[6].disable">

                        <el-radio-group v-model="printWorkflow[6].selected_value" v-on:change="next(printWorkflow[6])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[6].filter" v-model="printWorkflow[6].selected_value">
                               <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                   <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}gsm</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>

                    </el-collapse-item>
                    <el-collapse-item title="Select a lamination option" name="7" v-show="printWorkflow[7].show"
                                      :disabled="printWorkflow[7].disable">


                        <el-radio-group v-model="printWorkflow[7].selected_value" v-on:change="next(printWorkflow[7])" class="layout__width-100">
                            <div class="layout__padding-clear text__align-center">
                        <span v-for="size in printWorkflow[7].filter" v-model="printWorkflow[7].selected_value">
                                <el-radio-button :label="size.option" class="layout__border__all-1px-grey">
                                    <!--<img :src="size.image" class="layout__width-150px layout__padding-20px">-->
                                     <p class="layout__width-200px text__style-bold-900 text__colour-black">{{size.option}}</p>
                                </el-radio-button>
                        </span>
                            </div>
                        </el-radio-group>
                    </el-collapse-item>
                    <el-collapse-item title="Select a quantity" name="8" v-show="printWorkflow[8].show"
                                      :disabled="printWorkflow[8].disable">
                        <el-form :model="printWorkflow[8]" status-icon :rules="rules"
                                 ref="printWorkflow" class="layout__padding-clear">
                            <el-form-item prop="selected_value" class="text__colour-black">
                                <el-input class="text__colour-black" placeholder="Enter a quantity"
                                          v-model="printWorkflow[8].selected_value" clearable
                                          :disabled="!this.price.priceCode"
                                          v-on:input="postQuantity('printWorkflow')"></el-input>
                            </el-form-item>
                        </el-form>

                    </el-collapse-item>
                </el-collapse>
            </div>


            <div class="layout__position-sticky layout__position-left layout__width-30">
                <div class="">

                    <div class="colour__background-light-grey layout__padding-20px-40px layout__border__radius__top-20">
                        <p class="text__size-18 layout__padding-10px-0">Product Summary</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px text__transform-upper">
                            {{this.category}}</p>
                        <div v-if="this.predefinedSelections.subCategory !== ''">
                            <p class="layout__padding__top-10px">Subcategory</p>
                            <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px text__transform-upper">
                                {{this.predefinedSelections.subCategory}}</p>
                        </div>

                        <p class="layout__padding__top-10px">Size</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[0].selected_value}}</p>
                        <p class="layout__padding__top-10px">Orientation</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[1].selected_value}}</p>
                        <p class="layout__padding__top-10px">Page Count</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[2].selected_value}}</p>
                        <p class="layout__padding__top-10px">Fold Type</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[3].selected_value}}</p>
                        <p class="layout__padding__top-10px">Crease Style</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[4].selected_value}}</p>
                        <p class="layout__padding__top-10px">Paper Type</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[5].selected_value}}</p>
                        <p class="layout__padding__top-10px">Paper Weight</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[6].selected_value}}</p>
                        <p class="layout__padding__top-10px">Lamination</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[7].selected_value}}</p>
                        <p class="layout__padding__top-10px">Quantity</p>
                        <p class="text__colour-teal layout__border__bottom-1px-dotted-cdcfd1 layout__padding__bottom-10px">
                            {{this.printWorkflow[8].selected_value}}</p>

                    </div>
                    <div class="colour__background-red layout__padding-20px layout__border__radius__bottom-20">
                        <p class="text__size-24 text__align-right text__colour-white">
                            {{this.price.order_total}}</p>
                    </div>

                </div>
            </div>
        </div>

        <div class="layout__padding-clear layout__width-75">
            <div class="layout__padding-20-0 text__align-center">Ready to order your print? Then head to our Instant Print service, accessible from the menu. Need help creating your artwork?
                <el-button
                  class="layout__width-200px button-red layout__position-center layout__margin__top-10"
                  :disabled="!jobSpec"
                  @click="uploadArtwork"
                >
                    Upload artwork
                </el-button>
            </div>
        </div>

    </div>


</template>

<script>

    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import {dataFormatter} from '@/mixins/DataFormatter.js';
    import Router from '../../../router';

    export default {
        name: "getaquote",
        mixins: [axios, dataFormatter],
        props: {
            category: String,
            printSpec: Object,
            finalised: Boolean,
            preferences: Object,
            showOptionsBool: Boolean
        },
        components: {},
        computed: {},
        data() {

            const validateQuantity = (rule, value, callback) => {
                console.log('validate')
                if (this.printWorkflow[8].selected_value < this.price.minimumQty) {
                    callback(new Error('Quantity must be over the minimum quantity of ' + this.price.minimumQty + ' for this product'));
                } else {
                    callback();
                }
            };
            return {
                jobSpec: null,
                activeName: [],
                subActive:[],
                predefinedSelections: {
                    subCategory: '',
                    finishedSizeFilter: '',
                    finishedOrientationFilter: '',
                    foldTypeFilter: '',
                    creasingFilter: '',
                    pageCountFilter: '',
                    stockTypeFilter: '',
                    stockWeightFilter: '',
                    laminationFilter: '',
                    quantityFilter: ''
                },
                subCatStationery: [
                    {
                        title: 'Document Folder',
                        name: 'Docufolders',
                        finishedSizeFilter: 'A4',
                        finishedOrientationFilter: 'PORTRAIT',
                        foldTypeFilter: 'FOLDED',
                        creasingFilter: 'SIDEFOLD',
                        pageCountFilter: '4'
                    },
                    {
                        title: 'Business Card',
                        name: 'Business Card',
                        finishedSizeFilter: '85mm x 55mm',
                        finishedOrientationFilter: 'LANDSCAPE',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                    },
                    {
                        title: 'Compliment Slip',
                        name: 'Compliment Slip',
                        finishedSizeFilter: '210mm x 99mm',
                        finishedOrientationFilter: 'LANDSCAPE',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1'
                    },
                    {
                        title: 'Letterhead',
                        name: 'Letterhead',
                        finishedSizeFilter: 'A4',
                        finishedOrientationFilter: 'PORTRAIT',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1'
                    }

                ],
                subCatBanners: [
                    {
                        title: 'Display boards',
                        name: 'Display boards',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1',
                        laminationFilter: 'NONE',

                    },
                    {
                        title: 'Banners',
                        name: 'Banners',
                        foldTypeFilter: 'FLAT',
                        creasingFilter: 'N/A',
                        pageCountFilter: '1',
                        laminationFilter: 'NONE',
                    }

                ],
                printWorkflow: [
                    {
                        value: 0,
                        name: 'size',
                        disable: false,
                        show: true,
                        parameter_name: 'finishedSizeFilter',
                        property: 'finishedSize',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 1,
                        name: 'orientation',
                        disable: true,
                        show: true,
                        parameter_name: 'finishedOrientationFilter',
                        property: 'finishedOrientation',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 2,
                        name: 'count',
                        disable: true,
                        show: true,
                        parameter_name: 'pageCountFilter',
                        property: 'pageCount',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 3,
                        name: 'fold',
                        disable: true,
                        show: true,
                        parameter_name: 'foldTypeFilter',
                        property: 'foldType',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 4,
                        name: 'crease',
                        disable: true,
                        show: true,
                        parameter_name: 'creasingFilter',
                        property: 'creasing',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 5,
                        name: 'type',
                        disable: true,
                        show: true,
                        parameter_name: 'stockTypeFilter',
                        property: 'stockType',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 6,
                        name: 'weight',
                        disable: true,
                        show: true,
                        parameter_name: 'stockWeightFilter',
                        property: 'stockWeight',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 7,
                        name: 'lamination',
                        disable: true,
                        show: true,
                        parameter_name: 'laminationFilter',
                        property: 'lamination',
                        selected_value: '',
                        filter: []
                    },
                    {
                        value: 8,
                        name: 'qty',
                        disable: true,
                        show: true,
                        parameter_name: 'quantityFilter',
                        property: 'quantity',
                        selected_value: '0',
                        filter: [],
                    }
                ],

                price: {
                    minimumQty: 0,
                    priceCode: '',
                    order_total: 0.00
                },
                rules: {
                    selected_value: [{
                        message: '',
                        trigger: 'blur'
                    },
                        {
                            validator: validateQuantity
                        }],
                }

            }
        },
        mounted() {
            console.log(this.showOptionsBool)

            if (this.showOptionsBool) {
                this.showOptions();
            }

        },
        beforeUpdate() {

            // todo smash into session storage
        },
        methods: {
            selectCategory(name) {
                this.category = name;
                console.log('set category inside the get a price component ', this.category)

                this.printWorkflow[0].filter = []
                this.predefinedSelections.subCategory = '';

            },

            showOptions() {

                for (let i = 0; i < this.printWorkflow.length; i++) {
                    this.printWorkflow[i].show = true;
                    this.printWorkflow[i].disable = true;
                    this.printWorkflow[i].filter = [];
                }

                if (this.category == 'Stationery') {
                    // this.printWorkflow[2].disable = false;
                    // this.activeName = [];
                    this.subActive = [];
                    this.subActive.push("Stationery".toString());
                    // this.activeName.push("2".toString());
                    this.printWorkflow[0].show = false;
                    this.printWorkflow[1].show = false;
                    this.printWorkflow[3].show = false;
                    this.printWorkflow[4].show = false;

                } else if (this.category == 'Banners & Display boards') {
                    // this.activeName = [];
                    this.subActive = [];
                    this.subActive.push("Banners & Display boards".toString());
                    // this.activeName.push("0".toString());
                    // this.printWorkflow[0].disable = false;
                    this.printWorkflow[2].show = false;
                    this.printWorkflow[3].show = false;
                    this.printWorkflow[4].show = false;
                    this.printWorkflow[6].show = false;
                    this.printWorkflow[7].show = false;
                } else {
                    // this.activeName = [];
                    // this.activeName.push("0".toString());
                    // this.printWorkflow[0].disable = false;

                    this.firstFilter(0);
                }

                this.price.order_total = 0.00;
                this.price.priceCode = '';
                this.price.minimumQty = 0;

            },
            prepopulatedPreferences(cats, prepop) {
                console.log(prepop)

                this.predefinedSelections.subCategory = prepop.subCategory
                this.category = cats

                this.printWorkflow[0].selected_value = prepop.finishedSizeFilter;
                this.printWorkflow[1].selected_value = prepop.finishedOrientationFilter;
                this.printWorkflow[2].selected_value = prepop.pageCountFilter;
                this.printWorkflow[3].selected_value = prepop.foldTypeFilter;
                this.printWorkflow[4].selected_value = prepop.creasingFilter;
                this.printWorkflow[5].selected_value = prepop.stockTypeFilter;
                this.printWorkflow[6].selected_value = prepop.stockWeightFilter;
                this.printWorkflow[7].selected_value = prepop.laminationFilter;
                this.printWorkflow[8].selected_value = prepop.quantityFilter;

                if (this.category == 'Stationery') {
                    this.printWorkflow[2].disable = false;
                    this.activeName = [];
                    this.subActive = [];
                    this.subActive.push("Stationery".toString());
                    this.activeName.push("2".toString());
                    this.printWorkflow[0].show = false;
                    this.printWorkflow[1].show = false;
                    this.printWorkflow[3].show = false;
                    this.printWorkflow[4].show = false;

                } else if (this.category == 'Banners & Display boards') {
                    this.activeName = [];
                    this.subActive = [];
                    this.subActive.push("Banners & Display boards".toString());
                    this.activeName.push("0".toString());
                    this.printWorkflow[0].disable = false;
                    this.printWorkflow[2].show = false;
                    this.printWorkflow[3].show = false;
                    this.printWorkflow[4].show = false;
                    this.printWorkflow[6].show = false;
                    this.printWorkflow[7].show = false;
                } else {
                    this.activeName = [];
                    this.activeName.push("0".toString());
                    this.printWorkflow[0].disable = false;
                }

                this.prefilAllSelections()
            },
            // setSub(printSpec) {
            //
            //     this.printSpec = printSpec
            //
            //     this.showOptions();
            //
            //     for (let i = 0; i < this.printWorkflow.length; i++) {
            //         this.printWorkflow[i].selected_value = '';
            //     }
            //
            //     this.setSubCategory();
            //     this.firstFilter();
            //
            // },
            // selectedSubCategory() {
            //
            //
            //     this.setSubCategory();
            //
            //     this.firstFilter();
            // },
            // setSubCategory() {
            //     if (this.category == 'Stationery') {
            //         this.printWorkflow[0].selected_value = this.printSpec.finishedSizeFilter;
            //         this.printWorkflow[1].selected_value = this.printSpec.finishedOrientationFilter;
            //         this.printWorkflow[3].selected_value = this.printSpec.foldTypeFilter;
            //         this.printWorkflow[4].selected_value = this.printSpec.creasingFilter;
            //     } else if (this.category == 'Banners & Display boards') {
            //         this.printWorkflow[2].selected_value = this.printSpec.pageCountFilter;
            //         this.printWorkflow[3].selected_value = this.printSpec.foldTypeFilter;
            //         this.printWorkflow[4].selected_value = this.printSpec.creasingFilter;
            //         this.printWorkflow[7].selected_value = this.printSpec.laminationFilter;
            //     }
            // },




            selectSubcategory(prefilledOptions) {
                for (let i = 0; i < this.printWorkflow.length; i++) {
                    this.printWorkflow[i].selected_value = '';
                }


                this.predefinedSelections.subCategory = '';
                this.predefinedSelections.finishedSizeFilter = '';
                this.predefinedSelections.finishedOrientationFilter = '';
                this.predefinedSelections.foldTypeFilter ='';
                this.predefinedSelections.creasingFilter = '';
                this.predefinedSelections.pageCountFilter = '';
                this.predefinedSelections.stockTypeFilter = '';
                this.predefinedSelections.stockWeightFilter = '';
                this.predefinedSelections.laminationFilter = '';
                this.predefinedSelections.quantityFilter = '';


                if (this.category == 'Stationery') {


                    this.predefinedSelections.subCategory = prefilledOptions.name
                    this.predefinedSelections.finishedSizeFilter = prefilledOptions.finishedSizeFilter;
                    this.predefinedSelections.finishedOrientationFilter = prefilledOptions.finishedOrientationFilter;
                    this.predefinedSelections.foldTypeFilter = prefilledOptions.foldTypeFilter;
                    this.predefinedSelections.creasingFilter = prefilledOptions.creasingFilter;

                    this.printWorkflow[0].selected_value = this.predefinedSelections.finishedSizeFilter;
                    this.printWorkflow[1].selected_value = this.predefinedSelections.finishedOrientationFilter;
                    this.printWorkflow[3].selected_value = this.predefinedSelections.foldTypeFilter;
                    this.printWorkflow[4].selected_value = this.predefinedSelections.creasingFilter;

                    this.firstFilter(2);
                } else if (this.category == 'Banners & Display boards') {
                    this.predefinedSelections.subCategory = prefilledOptions.name
                    this.predefinedSelections.pageCountFilter = prefilledOptions.pageCountFilter;
                    this.predefinedSelections.foldTypeFilter = prefilledOptions.foldTypeFilter;
                    this.predefinedSelections.creasingFilter = prefilledOptions.creasingFilter;
                    this.predefinedSelections.laminationFilter = prefilledOptions.laminationFilter;

                    this.printWorkflow[2].selected_value = this.predefinedSelections.pageCountFilter;
                    this.printWorkflow[3].selected_value = this.predefinedSelections.foldTypeFilter;
                    this.printWorkflow[4].selected_value = this.predefinedSelections.creasingFilter;
                    this.printWorkflow[7].selected_value = this.predefinedSelections.laminationFilter;

                    this.firstFilter(0);
                }
            },
            // selectBannerSubcategory(prefilledOptions) {
            //
            //     for (let i = 0; i < this.printWorkflow.length; i++) {
            //         this.printWorkflow[i].selected_value = '';
            //     }
            //
            //     this.predefinedSelections.subCategory = '';
            //     this.predefinedSelections.finishedSizeFilter = '';
            //     this.predefinedSelections.finishedOrientationFilter = '';
            //     this.predefinedSelections.foldTypeFilter ='';
            //     this.predefinedSelections.creasingFilter = '';
            //     this.predefinedSelections.pageCountFilter = '';
            //     this.predefinedSelections.stockTypeFilter = '';
            //     this.predefinedSelections.stockWeightFilter = '';
            //     this.predefinedSelections.laminationFilter = '';
            //     this.predefinedSelections.quantityFilter = '';
            //
            //
            //
            //     this.predefinedSelections.subCategory = prefilledOptions.name
            //     this.predefinedSelections.pageCountFilter = prefilledOptions.pageCountFilter;
            //     this.predefinedSelections.foldTypeFilter = prefilledOptions.foldTypeFilter;
            //     this.predefinedSelections.creasingFilter = prefilledOptions.creasingFilter;
            //     this.predefinedSelections.laminationFilter = prefilledOptions.laminationFilter;
            //
            //     this.printWorkflow[2].selected_value = this.predefinedSelections.pageCountFilter;
            //     this.printWorkflow[3].selected_value = this.predefinedSelections.foldTypeFilter;
            //     this.printWorkflow[4].selected_value = this.predefinedSelections.creasingFilter;
            //     this.printWorkflow[7].selected_value = this.predefinedSelections.laminationFilter;
            //
            //     this.firstFilter(0);
            // },
















            firstFilter(index) {

                console.log('first filter')
                // const index = this.activeName[0]
                this.activeName = [];
                this.activeName.push(index.toString());
                this.printWorkflow[index].disable = false;

                this.clearFilters(parseInt(index))

                // console.log(window.sessionStorage.getItem('_category'))

                // this.category =  JSON.parse(window.sessionStorage.getItem('_category'))

                let skuFinder = '';

                skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetFilteredPrintCatalogue/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&category1Filter=` + encodeURIComponent(this.category)

                if (this.predefinedSelections.subCategory !== '') {

                    skuFinder = skuFinder + '&category2Filter=' + encodeURIComponent(this.predefinedSelections.subCategory)
                }

                this.printWorkflow.forEach(pw => {
                    if (pw.selected_value !== '' && this.printWorkflow[index].value > pw.value) {
                        skuFinder = skuFinder + '&' + pw.parameter_name + '=' + pw.selected_value
                    }
                })

                console.log(skuFinder)

                Axios.get(skuFinder)
                    .then(response => {


                        this.printWorkflow[index].filter = []
                        for (let i = 0; i < response.data.result.length; i++) {
                            // this.printWorkflow[index].filter.push(response.data.result[i][this.printWorkflow[index].property])

                            console.log("groupIcon")

                            this.printWorkflow[index].filter.push({
                                    'option': response.data.result[i][this.printWorkflow[index].property],
                                    'image': response.data.result[i]["groupIcon"]

                                }
                            )
                        }
                        this.printWorkflow[index].filter.sort()
                    })

            },
            next(workflow) {

                for (let printWorkflowIndex = 0; printWorkflowIndex < this.printWorkflow.length; printWorkflowIndex++) {
                    if (this.printWorkflow[printWorkflowIndex].value === workflow.value) {

                        for (let nextPrintWorkflowIndex = printWorkflowIndex + 1; nextPrintWorkflowIndex < this.printWorkflow.length; nextPrintWorkflowIndex++) {

                            const workflow = this.printWorkflow[nextPrintWorkflowIndex];

                            this.clearFilters(nextPrintWorkflowIndex);

                            if (workflow.show === true || (workflow.show === false && workflow.selected_value === '')) { // need to skip the fold type here

                                this.activeName.push(nextPrintWorkflowIndex.toString());
                                this.printWorkflow[nextPrintWorkflowIndex].disable = false;

                                let skuFinder = '';

                                skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetFilteredPrintCatalogue/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&category1Filter=` + encodeURIComponent(this.category)


                                // console.log(this.printSpec)

                                if (this.predefinedSelections.subCategory) {
                                    skuFinder = skuFinder + '&category2Filter=' + encodeURIComponent(this.predefinedSelections.subCategory)
                                }

                                this.printWorkflow.forEach(pw => {
                                    if (pw.selected_value !== '' && workflow.value > pw.value) {
                                        skuFinder = skuFinder + '&' + pw.parameter_name + '=' + pw.selected_value
                                    }
                                });

                                console.log(skuFinder)

                                Axios.get(skuFinder)
                                    .then(response => {

                                        // console.log('response from SKU search')

                                        console.log('RESPONSE FROM THE REQUEST')
                                        console.log(response.data.result)

                                        if (response.data.result.length === 1) {

                                            // this.printWorkflow[nextPrintWorkflowIndex].filter.push(response.data.result[0][this.printWorkflow[nextPrintWorkflowIndex].property]);

                                            console.log('*************** ONLY ONE OPTION ***************')

                                            this.printWorkflow[nextPrintWorkflowIndex].filter.push({
                                                    'option': response.data.result[0][this.printWorkflow[nextPrintWorkflowIndex].property],
                                                    'image': response.data.result[0]["groupIcon"]

                                                }
                                            )


                                            this.printWorkflow[nextPrintWorkflowIndex].selected_value = response.data.result[0][this.printWorkflow[nextPrintWorkflowIndex].property];
                                            this.next(this.printWorkflow[nextPrintWorkflowIndex])

                                        } else {
                                            this.printWorkflow[nextPrintWorkflowIndex].filter = [];
                                            for (let filterIndex = 0; filterIndex < response.data.result.length; filterIndex++) {


                                                this.printWorkflow[nextPrintWorkflowIndex].filter.push({
                                                        'option': response.data.result[filterIndex][this.printWorkflow[nextPrintWorkflowIndex].property],
                                                        'image': response.data.result[filterIndex]["groupIcon"]

                                                    }
                                                )

                                                // this.printWorkflow[nextPrintWorkflowIndex].filter.push(response.data.result[filterIndex][this.printWorkflow[nextPrintWorkflowIndex].property])
                                            }

                                            this.printWorkflow[nextPrintWorkflowIndex].filter.sort()
                                        }

                                        // todo get minimum quantity and do calc

                                        if (workflow.name === 'qty') {

                                            console.log(response.data.result)
                                            this.price.priceCode = response.data.result[0].priceCode;
                                            this.getMinimumQty()

                                        }
                                    })
                                break;
                            }
                        }
                        break;
                    }
                }
            },
            prefilAllSelections() {
                // console.log('printSpec in prefilAllSelections ', this.printSpec)

                for (let printWorkflowIndex = 0; printWorkflowIndex < this.printWorkflow.length; printWorkflowIndex++) {

                    console.log(printWorkflowIndex)
                //     if (this.printWorkflow[printWorkflowIndex].value === workflow.value) {

                        // for (let nextPrintWorkflowIndex = printWorkflowIndex; nextPrintWorkflowIndex < this.printWorkflow.length; nextPrintWorkflowIndex++) {

                            const workflow = this.printWorkflow[printWorkflowIndex];

                            // if (workflow.show === true || (workflow.show === false && workflow.selected_value === '')) { // need to skip the fold type here

                                this.activeName.push(printWorkflowIndex.toString());
                                this.printWorkflow[printWorkflowIndex].disable = false;

                                let skuFinder = '';

                                skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetFilteredPrintCatalogue/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&category1Filter=` + encodeURIComponent(this.category)

                                // console.log('prepop.subCat ', this.printSpec.subCategory)
                                if (this.predefinedSelections.subCategory !== '') {
                                    skuFinder = skuFinder + '&category2Filter=' + encodeURIComponent(this.predefinedSelections.subCategory)
                                }

                                this.printWorkflow.forEach(pw => {
                                    if (pw.selected_value !== '' && workflow.value > pw.value) {
                                        skuFinder = skuFinder + '&' + pw.parameter_name + '=' + pw.selected_value
                                    }
                                });

                                console.log(skuFinder)

                                Axios.get(skuFinder)
                                    .then(response => {
                                        // let rifat = printWorkflowIndex + 1;
                                         for (let filterIndex = 0; filterIndex < response.data.result.length; filterIndex++) {
                                                this.printWorkflow[printWorkflowIndex].filter.push({
                                                        'option': response.data.result[filterIndex][this.printWorkflow[printWorkflowIndex].property],
                                                        'image': response.data.result[filterIndex]["groupIcon"]
                                                    })

                                                // this.prefilAllSelections()
                                            }

                                        // todo get minimum quantity and do calc

                                        if (workflow.name === 'qty') {
                                            this.price.priceCode = response.data.result[0].priceCode;
                                            // this.getMinimumQty();
                                            this.saveQuantity();

                                            // console.log('after all calls ', this.printSpec)

                                        }
                                    })

                    // console.log('outside of Axios call', this.printSpec)
                    // break;

                }
            },
            clearFilters(indexFilter) {
                console.log('clearing filters')
                for (indexFilter; indexFilter < this.printWorkflow.length; indexFilter++) {


                    // typeof this.printSpec === 'undefined' || typeof this.printSpec[this.printWorkflow[indexFilter].parameter_name] === 'undefined'


                    if (this.predefinedSelections[this.printWorkflow[indexFilter].parameter_name] === '') {
                        console.log(this.printWorkflow[indexFilter].name)
                        console.log(this.printWorkflow[indexFilter].value)

                        this.printWorkflow[indexFilter].filter = []
                        this.printWorkflow[indexFilter].selected_value = ''
                    }

                    if (this.printWorkflow[indexFilter].name !== 'qty') {
                        this.price.order_total = 0.00;
                        this.price.priceCode = '';
                        this.price.minimumQty = 0;
                    }
                }

                console.log('FINISHED CLEARING FILTERS')

                this.$parent.finalised = false;
            },
            getMinimumQty() {


                console.log('priceCode inside method', this.price.priceCode)

                console.log('getting quantities')
                const urlQuantities = `${process.env.VUE_APP_PDFUPLOADAPIHOST}/api/v1/pdfUpload/Catalogue/FindMinimumQuantity`;

                console.log(urlQuantities)

                const getQuantities = {
                    "id": 0,
                    "fCode": "string",
                    "stockType": "string",
                    "pageWidth": 0,
                    "pageHeight": 0,
                    "actualPageWidth": 0,
                    "actualPageHeight": 0,
                    "pageOrientation": "string",
                    "stockWeight": 0,
                    "productRef": this.price.priceCode,
                    "lamination": "string",
                    "pageCount": 0,
                    "quantity": 0
                }

                console.log(getQuantities)


                console.log('RIFATIQBAL')

                Axios.post(urlQuantities, getQuantities, {})
                    .then(response => {

                        console.log('))))))) min qty ((((((((( ', response)

                        this.price.minimumQty = response.data

                        if (response.data === "") {
                            this.price.order_total = 'Please contact our Customer Service team for a price on 0191 917 9331'
                        }
                    })
                    .catch(error => {
                        console.log(error)
                        if (error.response.status === 500) {
                            this.price.order_total = 'Please contact our Customer Service team for a price on 0191 917 9331'
                        }
                    })
            },
            postQuantity(printWorkflow) {

                this.$refs[printWorkflow].validate((valid) => {
                    if (valid) {

                        this.saveQuantity();
                    } else {
                        return false;
                    }
                })
            },
            saveQuantity() {
                console.log('post quantity')

                // todo expose through gateway
                let skuFinder = `${process.env.VUE_APP_ACCOUNTSAPIHOST}/api/services/app/Catalogues/GetPrintProductDetails/?catalogueRef=${process.env.VUE_APP_CATALOGUE_REF}&orderSource=PDFUPLOAD&priceCode=` + this.price.priceCode + '&quantity=' + this.printWorkflow[8].selected_value

                console.log(skuFinder)

                Axios.get(skuFinder)
                    .then(response => {
                        console.log(response)

                        if (response.data.result.pricingResult.billNetTotalBeforeDiscount !== 0) {
                            this.price.order_total = this.returnFormattedCurrency(response.data.result.pricingResult.billNetTotalBeforeDiscount)
                        } else {
                            this.price.order_total = 'Please contact our Customer Service team for a price on 0191 917 9331'
                        }

                        // this.price.order_total = this.returnFormattedCurrency(response.data.result.pricingResult.billNetTotalBeforeDiscount)

                        this.$parent.finalised = true;
                        if (this.$parent.preferences) {
                            this.$parent.preferences.price_code = this.price.priceCode;
                            this.$parent.preferences.quantity = this.printWorkflow[8].selected_value;
                        }

                        this.jobSpec = response.data.result.printJobSpec;
                        this.jobSpec.productRef = response.data.result.pricingResult.productRef;



                        // console.log('printSpec state at the end of the fill process ', this.printSpec)
                    })
            },

            uploadArtwork() {
                sessionStorage.setItem('_getPriceSelection', JSON.stringify(this.jobSpec));

                Router.push({
                    name: '/instant-print',
                    params: {
                        isCustomStep: true,
                    },
                });
            },
        }
    };
</script>